import { Calculation } from './_types';

export const LIB_CALCULATIONS_FRUIT_DISEASE: Calculation[] = [

    //Calculated values
    {
        id: "frut_disease_none_calc",
        unit: "%",
        label: "Unaffected Fruit",
        tag: "UFR",
        defaultChart: "chart_candle_sd",
        defaultBucket: "bucket_frut_disease_none_calc",
        format: "###%",
        min: 0,
        max: 100,
        suggestMin: 0,
        suggestMax: 100,
        subjectId: "fruit_disease_calc",
    },
    {
        id: "frut_disease_low_calc",
        unit: "%",
        label: "Low Severity",
        tag: "LSE",
        defaultChart: "chart_candle_sd",
        defaultBucket: "bucket_frut_disease_low_calc",
        format: "###%",
        min: 0,
        max: 100,
        suggestMin: 0,
        suggestMax: 100,
        subjectId: "fruit_disease_calc",
    },
    {
        id: "frut_disease_med_calc",
        unit: "%",
        label: "Moderate Severity",
        tag: "MSE",
        defaultChart: "chart_candle_sd",
        defaultBucket: "bucket_frut_disease_med_calc",
        format: "###%",
        min: 0,
        max: 100,
        suggestMin: 0,
        suggestMax: 100,
        subjectId: "fruit_disease_calc",
    },
    {
        id: "frut_disease_high_calc",
        unit: "%",
        label: "High Severity",
        tag: "MSE",
        defaultChart: "chart_candle_sd",
        defaultBucket: "bucket_frut_disease_high_calc",
        format: "###%",
        min: 0,
        max: 100,
        suggestMin: 0,
        suggestMax: 100,
        subjectId: "fruit_disease_calc",
    },

];